import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedComponentsModule } from './components/shared-components.module';
import { SharedPipesModule } from './pipes/shared-pipes.module';
import { SharedDirectivesModule } from './directives/shared-directives.module';


@NgModule({
  imports: [
    CommonModule,
    SharedComponentsModule,
    SharedPipesModule,
    SharedDirectivesModule,

  ],
  providers: [],
  exports: [
    SharedComponentsModule,
    SharedPipesModule,
    SharedDirectivesModule,


  ],
  declarations: [
  ]
})
export class SharedModule { }
